
import React from "react";
import "./MGAlertModal.css";
import alert_close from "../../images/alert_lose.svg"

export default function MGAlertModal({
    content,
    onClose
}) {
    return (
        <div className="modal-overlay">
            <div className="alert-modal-wrapper">
                <button
                    type="button"
                    className="alert-modal-close"
                    onClick={onClose}
                    aria-label="Fechar modal"
                >
                    <img src={alert_close} alt="Fechar modal" />
                </button>

                <div className="alert-modal">
                    {content}
                </div>
            </div>
        </div>
    );
}
